import ExternalTicketingClient from 'src/models/external-ticketing/ExternalTicketingClient'
import Model, { encoders, ID } from 'src/models/Model'
import TicketType from 'src/models/showing/TicketType'

export default class ExternalTicketingClientTicketType extends Model {
  static name = 'ExternalTicketingClientTicketType'

  static versioned = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Site]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      externalTicketingClient: {
        type: ExternalTicketingClient,
        default: null,
        encode: encoders.hasOne
      },
      ticketType: {
        type: TicketType,
        default: null,
        encode: encoders.hasOne
      }
    }
  }
}
